<!-- Check oflline network status-->
<div class="alert-network-offline" [class.alert-network-offline--active]="numNetworkErrors > 3">
  <i class="fas fa-wifi"></i> {{ 'web.page_is_offline' | translate }}
</div>

<router-outlet></router-outlet>

<a (click)="goTop()" class="cd-top text-replace js-cd-top" [class.cd-top--active]="isScroll">
  <i class="material-icons"> arrow_upward </i>
</a>

@if (!kioskMode && client.use('notification')) {
  <app-push-notification id="push-notification"></app-push-notification>
}
@if (!isDebug) {
  <app-banner-container>
    <app-banner fixed #banners></app-banner>
  </app-banner-container>
}

<!-- WAKE LOCK -->
@if (wakeLockSet) {
  <aside class="app-info-modal" role="alert">
    <div class="d-flex flex-column">
      <div>
        {{ 'web.wake_lock_info' | translate }}
      </div>
      <i class="fa fa-arrow-circle-down fa-2x app-info-modal__icon"></i>
    </div>
  </aside>
}
<!-- END WAKE LOCK -->

<!-- BANNER -->
<app-banner-container>
  <app-banner pop-up #banners></app-banner>
</app-banner-container>
